import BrickFinder from "zengular/src/brick-finder";
export default function fileInputReader(node) {
  if (node instanceof BrickFinder) node = node.node;
  var file = node.files[0];
  var reader = new FileReader();
  return {
    text: function text() {
      var maxFileSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new Promise(function (resolve, reject) {
        if (file instanceof Blob) {
          if (maxFileSize !== null && maxFileSize !== -1 && file.size > maxFileSize) reject({
            error: 'size',
            allowed: maxFileSize
          });
          reader.addEventListener('load', function (e) {
            return resolve(e.target.result);
          });
          reader.readAsText(file);
        } else {
          reject(null);
        }
      });
    },
    dataURL: function dataURL() {
      var maxFileSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return new Promise(function (resolve, reject) {
        if (file instanceof Blob) {
          if (maxFileSize !== null && maxFileSize !== -1 && file.size > maxFileSize) reject({
            error: 'size',
            allowed: maxFileSize
          });
          reader.addEventListener('load', function (e) {
            return resolve(e.target.result);
          });
          reader.readAsDataURL(file);
        } else {
          reject(null);
        }
      });
    }
  };
}